export const DASHBOARD_PERIOD_OPTIONS = ['last7Days', 'last30Days', 'last90Days'] as const;

export type DashboardPeriod = (typeof DASHBOARD_PERIOD_OPTIONS)[number];

export const DASHBOARD_PERIOD_DAYS: Record<DashboardPeriod, number> = {
  last7Days: 7,
  last30Days: 30,
  last90Days: 90,
};
